import React, { useEffect, useRef } from "react";
import Head from "next/head";
import { motion, useAnimation, useInView } from "framer-motion";

type Props = {};

const textVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.8,
      ease: "easeOut",
    },
  }),
};

const Banner2: React.FC<Props> = () => {
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [controls, isInView]);
  return (
    <>
      <Head>
        <style jsx global>{`
          @media (max-width: 767px) {
            .banner-section {
              background-position: 30% top !important;
            }
          }
        `}</style>
      </Head>
      <section
        className="banner-section relative w-full h-[100vh] min-h-[100vh] bg-cover bg-no-repeat flex items-center justify-center md:justify-start md:items-start bg-bottom"
        style={{
          backgroundImage: `url('/banner2.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        {/* Content - Mobile adjustments only */}
        <div className="relative z-10 text-center mt-8 sm:mt-16 h-full md:text-left px-4 sm:px-6 pt-8 sm:pt-16 md:pt-32 md:pl-16 max-w-[90vw]">
          <motion.h1
            ref={ref}
            className="text-4xl sm:text-5xl md:text-[6vw] font-bold title uppercase leading-tight text-black"
            initial="hidden"
            animate={controls}
          >
            <motion.span className="block" variants={textVariants} custom={0}>
              Explore
            </motion.span>
            <motion.span
              className="block mt-3 sm:mt-4 md:mt-6"
              variants={textVariants}
              custom={1}
            >
              Experience
            </motion.span>
            <motion.span
              className="block mt-3 sm:mt-4 md:mt-6"
              variants={textVariants}
              custom={2}
            >
              Expand
            </motion.span>
          </motion.h1>
        </div>
      </section>
    </>
  );
};

export default Banner2;
